import { SVGProps } from "react";

export function CircleWithExclamationMarkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 6C12.6213 6 13.125 6.50368 13.125 7.125V11.625C13.125 12.2463 12.6213 12.75 12 12.75C11.3787 12.75 10.875 12.2463 10.875 11.625V7.125C10.875 6.50368 11.3787 6 12 6ZM12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
        fill="#F44545"
      />
    </svg>
  );
}
